import React, { Component } from 'react';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import { clearFix } from 'js/config/style';

const Container = styled.div.attrs({ className: 'constraint' })`
  position: relative;
  width: ${({ size }) => `calc(4rem + ${size || '500px'})`};
  max-width: 100%;
  margin: 0 auto;
  margin-top: ${({ offset }) => (offset ? `calc(${offset} * -1)` : '0')};
  padding: 0
    ${({ padding }) =>
      padding || typeof padding === 'undefined' ? (typeof padding === 'undefined' ? '2rem' : padding) : '0'};
  ${clearFix}
`;

@inject('pageWidth', 'offsetManager')
@observer
export default class Constraint extends Component {
  componentDidMount() {
    this.props.offsetManager.setConstraintProps(
      this.props.offset
        ? {
            offset: this.props.offset,
            bottomOffset: this.props.bottomOffset,
          }
        : { offset: '0', bottomOffset: '0' },
    );
  }

  render() {
    const { size, pageWidth, offsetManager, children, offset, ...rest } = this.props;
    return (
      children && (
        <Container
          size={size || pageWidth || '400px'}
          offset={offset ? (parseInt(offsetManager.bottomOffset) ? offsetManager.bottomOffset : offset) : offset}
          children={children}
          {...rest}
        />
      )
    );
  }
}
